<template>
	<div class="note-card-wrapper">
		<div class="note-card">
			<div class="title-group">
				<h1>Greenbelt Program</h1>
				<h2>{{ form_name }}</h2>
			</div>
			<el-steps v-bind:class="{active: navActive}" direction="vertical">
				<el-step
				v-for="{ display, store_key } in form_sections"
				:key="`section-${store_key}`"
				@click.native="goToForm(store_key)"
				:title="display"
				:status="getStatus(store_key)"
				>
			</el-step>
		</el-steps>
		<div class="button-nav">
			<el-button @click="formBack()" :disabled="backDisabled" type="default"><i class="el-icon-arrow-left"></i><span class="hide-on-mobile">Back</span></el-button>

			<el-button @click="formForward()" type="success"><span class="hide-on-super-mobile">{{forward_message}}</span><i class="el-icon-arrow-right"></i></el-button>
		</div>
	</div>
	<el-button @click="navActive = !navActive" class="navCtrl" type="default" :icon="navActive ? 'el-icon-close' : 'el-icon-menu'"></el-button>
	<a class="non-styled-link preview-button" :href="application_pdf" target="_blank">
		<i class="el-icon-printer"></i>
		<span class="non-mobile-only">Preview</span>
	</a>
	<div class="save-status" style="display:flex;">
		<div class="" style="flex-grow:1;">
			<h3 style="text-align:center;font-size:14px;margin-top:0;color:#00B65D" v-if="last_saved">Last saved {{ last_saved_dynamic }}</h3>
		</div>
		<div class="">
			<i class="el-icon-loading" :class="{iShow:saving_application}" />
		</div>

	</div>


	<hr style="opacity:1;">
	<div v-if="deadline" class="subnotes">
		<strong>Deadline:</strong> {{ formatted_deadline }}
	</div>
	<div class="subnotes">
		<strong>Greenbelt contact:</strong><br>
		Eric Davis &nbsp;| &nbsp; 843-202-7214<br>
		EDavis@charlestoncounty.org</div>
		<div class="subnotes">
			<strong>NOTE:</strong> &nbsp;Applications missing information or any of the attachments may be deemed incomplete and deferred until the next funding cycle.</div>
		</div>
	</template>

	<script>

	import { mapState, mapActions } from 'vuex';
	import { mapFields } from 'vuex-map-fields';
	import moment from 'moment';
	import { findIndex, findKey } from 'lodash';
	const getSections =
	(form_type) => import(`@/js/forms/store/${form_type}-request-store`);

	export default{
		props: ['form_name', 'form_type'],
		async created(){
			setInterval(() => {
				this.last_saved_dynamic = moment(this.last_saved).fromNow();
			}, 1000)
			this.form_sections = (await getSections(this.form_type)).sections;
		},
		watch:{
			sessions_active(newVal, oldVal){
				if(newVal > 1){
					if(newVal > oldVal)
					this.$notify({
						message:`There are currently ${this.sessions_active} sessions (including this one) open on your application. This means that the application is open (or was open within the last minute) either in another browser tab or on another device.`,
						duration:12000,
						showClose:true,
						position:'bottom-left'
					});
				}
			}
		},
		computed: {
			...mapFields(['last_saved', 'sessions_active', 'saving_application']),
			...mapState('application', ['section_status']),
			...mapState(['deadline']),
			formatted_last_save(){
				// return moment(this.last_saved).format('MMM Do [@] hh:mm:ss A');
				return moment(this.last_saved).fromNow();
			},
			forward_message(){
				return (this.current_section_index === this.form_sections.length - 1) ? 'Submit' : 'Next';
			},
			backDisabled(){
				return (this.current_section_index === 0)
			},
			application_pdf(){
				return `${process.env.VUE_APP_API_PATH}/files/application-viewer.php/?hash=${this.$store.state.route.params.application_hash}`;
			},
			current_section(){
				const path_array = this.$store.state.route.path.split('/');
				return (path_array[path_array.length - 1]).replace(/-/g, '_');
			},
			current_section_index(){
				return findIndex(this.form_sections, { store_key: this.current_section })
			},
			formatted_deadline(){
				return this.deadline.format('MM/DD/YYYY')
			}
		},
		methods: {
			...mapActions('application', ['saveApplication']),
			validateForm(){
				this.$emit('validate-form');
			},
			pushToPath(path){
				// Needed to translate underscores to hypens
				const clean_path = path.replace(/_/g, '-');
				this.$router.push(clean_path);
			},
			goToForm(section){
				this.navActive = false;
				if(section !== this.current_section){
					this.validateForm();
					this.pushToPath(section);
				}
			},
			formBack(){
				this.navActive = false;
				if(this.current_section_index !== 0){
					this.validateForm();
					const new_panel_name = this.form_sections[this.current_section_index - 1].store_key;
					this.pushToPath(new_panel_name);
				}
			},
			formForward(){
				this.navActive = false;
				if(this.current_section_index === this.form_sections.length - 1){
					this.submitApplication();
				} else {
					if(this.current_section_index < 9){
						this.validateForm();
						const new_panel_name = this.form_sections[this.current_section_index + 1].store_key;
						this.pushToPath(new_panel_name);
					}
				}
			},
			async submitApplication(){
				this.navActive = false;
				this.validateForm();
				let application_not_ready = findKey(this.section_status, status => !status) !== undefined
				if(application_not_ready){

					// Fixes overlapping rapid fire notifications.
					await new Promise(resolve => setTimeout(resolve, 1))

					this.$notify.error({
						title: 'Application Incomplete',
						message: 'All sections must be completed before submission.'
					});
				} else {
					this.$emit('submit-application');
				}
			},
			getStatus(section){
				if(section === this.current_section){
					return 'process'
				}
				switch(this.section_status[section]){
					case null:
					return 'wait'
					case true:
					return 'success'
					case false:
					return 'error'
				}
			}
		},
		data(){
			return{
				last_saved_dynamic:null,
				navActive:false,
				form_sections: []
			}
		}
	}
	</script>

	<style scoped>

	@media (min-width:1001px){
		.preview-button{
			padding:7px 7px;font-size:14px;
			display:block;border-radius:8px;border:1px solid rgba(0,0,0,.2);
			text-align:center;
			max-width:90%;
			width:200px;
			margin:15px auto 15px;

		}
		.preview-button i{
			margin-right:7px;
		}
	}
	@media(max-width:1000px){
		.preview-button{
			position:relative;
			display:block;
			width:30px;
			flex-shrink:0;
		}
		.preview-button i {
			font-size:15px;
			position:absolute;
			top:50%;
			left:50%;
			transform:translate(-50%,-50%);
		}
	}

	.save-status i{
		transition:opacity .2s ease;
		font-size:20px;
	}
	.save-status i:not(.iShow){
		opacity:0
	}
	.title-group{
		margin-bottom:20px;
	}
	.title-group h1, .title-group h2{
		text-align: center;
	}
	.el-step{
		cursor: pointer;
		transition: .1s all linear;
		margin-bottom:5px;
		flex-basis:auto !important;
	}
	.el-step:hover >>> .el-step__icon{
		transition: .1s all linear;
		transform: scale(1.1);
		color:teal;
		border-color:teal;
	}
	.el-step:hover >>> .el-step__title{
		transition: .1s all linear;
		color:teal;
	}
	.button-nav{
		margin-top:15px;
		display:flex;
		justify-content:space-between;
	}
	.button-nav > button{
		flex-grow:1;
	}
	.note-card-wrapper{position:fixed;max-height:100vh;width:260px;}
	#SaveForLater, #PrintApplication{

		margin-top:5px;
		margin-bottom:5px;
		border:none;
		background-color:transparent;
		margin-left:0px;
	}
	.subnotes{
		color:#909399;
		font-size:14px;
		margin-top:12px;
	}
	@media(max-height:820px){
		#SaveForLater, #PrintApplication{
			margin:0 !important;
		}
		div.button-nav{
			margin-top:5px;
		}
		div.note-card{
			padding:20px 25px;
		}
		#nav-panel h1{
			font-size:18px;
			margin-top:-35px;
		}
		h2{
			font-size:15px;
			margin-bottom:0px;
		}
		.el-button{
			padding:8px 12px;
		}
		.subnotes{
			margin-top:6px;
		}

	}
	@media(max-height:670px){
		/* .subnotes{display:none;} */
		hr{display:none;}
	}

	</style>
	<style>
	.el-notification__content{
		text-align:left !important;
		font-size:13px;
		line-height:1;
		margin-top:0
	}
	.el-notification__content p {
		text-align:left !important;
		font-size:15px;
		line-height:1.2;
	}
	.el-notification.left{
		width:420px;

	}
	@media(max-height:820px){
		body{margin-top:0px;}
		.el-main{
			padding:0px;
			margin: -1px auto 0 auto;
		}
		.el-step.is-vertical .el-step__title{
			padding-bottom:0px;
		}
	}
	.non-styled-link{
		text-decoration:none;
		color:#606266;
	}
	.non-styled-link:hover{
		color: #409EFF;
	}
	</style>
